import { Component, OnInit, Inject, Input, EventEmitter, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-modal-variado',
  templateUrl: './modal-variado.component.html',
  styleUrls: ['./modal-variado.component.scss']
})
export class ModalVariadoComponent implements OnInit {
  @Output() confirmation : EventEmitter<Boolean> = new EventEmitter();
  constructor(
    public dialogo: MatDialogRef<ModalVariadoComponent>,
    @Inject(MAT_DIALOG_DATA) public config: any) { }

    
    cerrarDialogo(): void {
      this.dialogo.close(false);
    }
    confirmado(): void {
      this.dialogo.close(true);
    }

  ngOnInit() {
  }
  close() {
    this.cerrarDialogo();
  }
  confirmationAndclose(){
    this.close();
    this.confirmation.emit(true);
  }

}
